import React from 'react';
import { LogOut } from 'lucide-react';
import ChallengeManager from './ChallengeManager';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const AdminPanel: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const navigate = useNavigate();

  if (!isAuthenticated) {
    return null;
  }

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/admin/login');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-8">
        <div>
          <p className="text-gray-400">Logged in as: <span className="text-white">{user?.email}</span></p>
        </div>
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 px-4 py-2 text-red-400 hover:text-red-300 transition-colors"
        >
          <LogOut size={20} />
          Logout
        </button>
      </div>
      <ChallengeManager />
    </div>
  );
};

export default AdminPanel;